/**
 * PDF reports are built by the server and saved here. Fetched rather than
 * navigated to so the same path works in the desktop app (same reasoning as
 * export-excel.ts).
 */

import { ApiError } from "./api.js";
import { activeWorkspaceHeader, fileUrl, saveBlob } from "./transport.js";

/** Fetch a `…/report.pdf` route and save the result. `path` starts with `/projects`. */
export async function downloadPdf(path: string, fileName: string): Promise<void> {
  const response = await fetch(fileUrl(`/api/v1${path}`), {
    credentials: "include",
    headers: activeWorkspaceHeader(),
  });
  if (!response.ok) {
    const payload = (await response.json().catch(() => ({}))) as { error?: string; code?: string };
    throw new ApiError(payload.error ?? `Report failed (${response.status})`, response.status, payload.code);
  }
  await saveBlob(await response.blob(), fileName);
}
